<template>
  <q-card class="person-card">
    <div class="person-card__avatar-container">
      <q-avatar
        size="100px"
        color="grey-3"
        text-color="grey-6"
        class="person-card__avatar"
      >
        <q-img
          v-if="person.primaryFace && person.primaryFace.imageUrl"
          :src="person.primaryFace.imageUrl"
          :ratio="1"
          fit="cover"
          class="grayscale"
        >
          <template v-slot:error>
            <q-icon
              name="fa fa-user-circle"
              size="40px"
            />
          </template>
        </q-img>
        <q-icon
          v-else
          name="fa fa-user-circle"
          size="40px"
        />
      </q-avatar>
    </div>

    <q-card-section class="q-pa-sm text-center">
      <div
        class="text-body2 ellipsis"
        :class="person.label ? 'text-weight-medium text-grey-5' : 'text-grey-5 text-italic'"
      >
        {{ person.label || 'Unnamed Person' }}
      </div>
      <div class="text-caption text-grey-6">
        {{ faceCount }} face{{ faceCount !== 1 ? 's' : '' }}
      </div>
      <div class="text-caption text-grey-5">
        Trashed {{ trashedAt }}
      </div>
    </q-card-section>

    <q-card-actions class="q-pa-xs q-pt-none justify-center">
      <!-- TODO: Make these btns as their own components with their async calls contained inside -->
      <q-btn
        size="sm"
        flat
        round
        dense
        icon="fa fa-undo"
        color="primary"
        :loading="restoring"
        :disable="restoring"
        @click.stop="restorePerson"
      >
        <q-tooltip :delay="400">Restore</q-tooltip>
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { date } from 'quasar';
import { Person } from '@/analysis/types';
import notify from '@/components/notify';
import { restore } from './person';

export default defineComponent({
  emits: ['restored'],
  components: {},
  props: {
    person: {
      type: Object as () => Person,
      required: true,
    },
  },
  data() {
    return {
      restoring: false,
    };
  },
  computed: {
    faceCount(): number {
      return this.person.faceCount || 0;
    },
    trashedAt(): string {
      return this.person.trashedAt ? date.formatDate(this.person.trashedAt, 'MMM D, YYYY') : '';
    },
  },
  methods: {
    async restorePerson() {
      this.restoring = true;
      try {
        await restore(this.person.id);
        notify('Person restored.');
        this.$emit('restored', this.person);
      } catch (e) {
        notify('Failed to restore person.', 'negative');
      } finally {
        this.restoring = false;
      }
    },

  },
});
</script>

<style scoped>
.person-card {
  cursor: default;
}

.person-card__avatar-container {
  display: flex;
  justify-content: center;
  padding: 16px;
}

.person-card__avatar {
  border: 2px solid #e0e0e0;
}

.grayscale :deep(img) {
  filter: grayscale(100%);
}
</style>
